import { createApp } from 'vue'
import App from './App.vue'

import 'element-plus/theme-chalk/index.css'
import ElementPlus from 'element-plus'
import "@element-plus/icons-vue"
import "babel-polyfill"
import "event-source-polyfill"

const app = createApp(App)
//自定义指令-列表新增元素后自动滚动底部
app.directive("scrollBottom", {
    updated(el) {
        // 这里的el即是绑定指令处的dom元素
        // el.scrollTo({
        //     top: el.scrollHeight - el.clientHeight,
        //     behavior: "smooth"
        // })
        el.scrollTo(0, el.scrollHeight - el.clientHeight)
    }
})

app.config.errorHandler = (err) => {
    console.log(err);
};
// 屏蔽警告信息
app.config.warnHandler = (message) => {
    console.log(message);
};

app.use(ElementPlus).mount('#app')
